import klCustomerCenterSubscriptionUsageCtrl from './klCustomerCenterSubscriptionUsageCtrl';
import klCustomerCenterSubscriptionCtrl from './klCustomerCenterSubscriptionCtrl';
import klCustomerCenterRatePlanCtrl from './klCustomerCenterRatePlanCtrl';
import klCustomerCenterRatePlanAmendCtrl from './klCustomerCenterRatePlanAmendCtrl';
import klCustomerCenterCancelCtrl from './klCustomerCenterCancelCtrl';
import klCustomerCenterCancelResellerCtrl from './klCustomerCenterCancelResellerCtrl';
import klCustomerCenterCancelEnterpriseCtrl from './klCustomerCenterCancelEnterpriseCtrl';
import klChurnSurveyCtrl from './klChurnSurveyCtrl';
import klEnterpriseCancelledCtrl from './klEnterpriseCancelledCtrl';
import klCustomerCenterUncancelCtrl from './klCustomerCenterUncancelCtrl';
import klCustomerCenterBuyOrdersCtrl from './klCustomerCenterBuyOrdersCtrl';
import klCustomerCenterBuyCtrl from './klCustomerCenterBuyCtrl';

export default function (app) {
  klCustomerCenterSubscriptionUsageCtrl(app);
  klCustomerCenterSubscriptionCtrl(app);
  klCustomerCenterRatePlanCtrl(app);
  klCustomerCenterRatePlanAmendCtrl(app);
  klCustomerCenterCancelCtrl(app);
  klCustomerCenterCancelResellerCtrl(app);
  klCustomerCenterCancelEnterpriseCtrl(app);
  klChurnSurveyCtrl(app);
  klEnterpriseCancelledCtrl(app);
  klCustomerCenterUncancelCtrl(app);
  klCustomerCenterBuyOrdersCtrl(app);
  klCustomerCenterBuyCtrl(app);
}
